import React from "react";
import { convertUtcToFormattedTime } from "../../../util/AppUtils";
import ShowLightText from "../../../common/SmallButUseFull/ShowLightText";

/**
 * Rebased component - Displays rebased version information
 * @param {Object} vdt - Version data object containing version_content and audit_updated_at
 */
const Rebased = ({ vdt,showBasedOnText = false }) => {
  if (!vdt || !vdt.version_content) {
    return null;
  }

  const { version_content, audit_updated_at } = vdt;
  const { partNumber,procedure_number, rev, current_status } = version_content;
  return (
    <ShowLightText
      text={
        <>
          {showBasedOnText ? "Based" : "Rebased"} on {partNumber ? partNumber : procedure_number} Rev {rev}, When {current_status}, at{" "}
          {convertUtcToFormattedTime(audit_updated_at)}
        </>
      }
    />
  );
};

export default Rebased;

